<template>
    <div v-if="lang === 'ru'" class="flex w-full flex-column gap-2">
        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            1. Общие положения
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            1.1. Настоящий документ является официальным предложением (офертой) проекта PayWave, управляемого командой без образования юридического лица, и содержит условия предоставления доступа к сервису PayWave (далее — «Сервис», «Платформа»), доступному по адресу: <a href="https://pay-wave.co/" class="text-primary" target="_blank">https://pay-wave.co/</a>, а также через Telegram-ботов, мини-приложения и иные интерфейсы.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            1.2. Совершение Пользователем регистрационных или иных действий, направленных на использование Сервиса, означает полное и безоговорочное принятие настоящей Оферты и всех её условий.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            2. Предмет оферты
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            2.1. Сервис предоставляет информационную платформу для организации взаиморасчётов между Пользователями и независимыми сторонами (мерчантами, агентами, иными физическими или юридическими лицами), осуществляющими обмен валют и цифровых активов, переводы денежных средств и иные сопутствующие услуги.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            2.2. PayWave не является кредитной организацией, платёжной системой, оператором электронных денежных средств или финансовым посредником. Платформа не хранит средства и не принимает платежи от имени третьих лиц. Все операции проводятся напрямую между Пользователями и исполнителями, отобранными в рамках платформы.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            3. Условия использования
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            3.1. Доступ к Сервису предоставляется после регистрации и, при необходимости, прохождения процедур верификации личности (KYC/AML).
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            3.2. Пользователь обязуется предоставлять достоверную и актуальную информацию. За последствия, вызванные предоставлением ложных данных, Пользователь несёт полную ответственность.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            3.3. PayWave вправе отказать в доступе к Сервису или временно ограничить использование функций без объяснения причин, в случае выявления подозрений на нарушение закона, мошенничество, неправомерное использование или иные риски.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            4. Ответственность и ограничения
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            4.1. Сервис PayWave обеспечивает технологическую инфраструктуру и систему контроля исполнения заявок на перевод и обмен средств. Все операции проводятся через проверенных и отобранных партнёров (мерчантов), с которыми проект выстраивает взаимодействие. Мы предпринимаем меры по обеспечению надежности таких исполнителей, однако не несем ответственности за действия, совершаемые за пределами платформы и наших технических механизмов.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            4.2. Курсы обмена, комиссии и условия операций отображаются в интерфейсе Сервиса до совершения перевода и подлежат обязательному исполнению после подтверждения Пользователем. Мы гарантируем, что Пользователь получит курс, указанный при подтверждении, либо операция будет отменена с возвратом средств.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            4.3. Срок исполнения операций может зависеть от внешних факторов (работа банков, платёжных систем, местных ограничений), и не всегда может быть гарантирован. PayWave прилагает разумные усилия для соблюдения заявленных сроков исполнения.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            4.4. Сервис не предоставляет инвестиционных, финансовых или юридических рекомендаций. Пользователь самостоятельно принимает решения об использовании функционала платформы.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            5. Отсутствие лицензии
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            5.1. Проект PayWave не обладает лицензией на осуществление финансовой, банковской или иной регулируемой деятельности. Сервис работает в модели peer-to-peer (P2P) и предоставляет инфраструктуру для организации обменов и переводов между пользователями и исполнителями.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            5.2. Используя Сервис, Пользователь осознаёт и принимает характер работы платформы, основанной на взаимодействии с независимыми участниками, а также связанные с этим особенности.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            6. Персональные данные
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            6.1. Обработка персональных данных осуществляется в соответствии с Политикой конфиденциальности, опубликованной по адресу: <a href="https://pay-wave.co/policy/" class="text-primary">https://pay-wave.co/policy/</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            6.2. Пользователь соглашается на обработку персональных данных, включая передачу необходимых сведений третьим лицам для выполнения операций, верификации и обеспечения правовых требований.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            7. Порядок разрешения споров
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            7.1. Все споры и претензии разрешаются путём переговоров, в том числе через указанные контактные каналы.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            7.2. При невозможности урегулирования конфликта в досудебном порядке, спор может быть передан на рассмотрение по месту нахождения ответственного лица проекта или на альтернативные платформы разрешения споров (ODR).
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            8. Изменения условий
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            8.1. Сервис оставляет за собой право вносить изменения в настоящую Оферту в любое время без предварительного уведомления. Актуальная версия доступна по адресу: <a href="https://pay-wave.co/terms/" class="text-primary">https://pay-wave.co/terms/</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            8.2. Продолжение использования Сервиса означает согласие Пользователя с изменениями условий.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            9. Контактная информация
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Проект PayWave
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Email: <a href="mailto:info@pay-wave.co" class="text-primary">info@pay-wave.co</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Telegram: <a href="https://t.me/pw_origin_bot" class="text-primary" target="_blank">https://t.me/pw_origin_bot</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Сайт: <a href="https://pay-wave.co/" class="text-primary" target="_blank">https://pay-wave.co/</a>
        </p>
    </div>
    <div v-else class="flex w-full flex-column gap-2">
        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            1. General Provisions
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            1.1. This document is an official offer (public offer) of the PayWave project, managed by a team without forming a legal entity, and contains the terms of access to the PayWave service (hereinafter referred to as the "Service", "Platform"), available at <a href="https://pay-wave.co/" class="text-primary" target="_blank">https://pay-wave.co/</a>, as well as through Telegram bots, mini-apps, and other interfaces.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            1.2. By registering or performing any actions aimed at using the Service, the User fully and unconditionally accepts this Offer and all its terms.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            2. Subject of the Offer
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            2.1. The Service provides an information platform for organizing settlements between Users and independent parties (merchants, agents, other individuals or legal entities) who carry out currency and digital asset exchanges, money transfers, and other related services.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            2.2. PayWave is not a credit institution, payment system, e-money operator, or financial intermediary. The Platform does not store funds and does not accept payments on behalf of third parties. All transactions are carried out directly between Users and executors selected within the platform.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            3. Terms of Use
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            3.1. Access to the Service is provided after registration and, if necessary, completion of identity verification procedures (KYC/AML).
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            3.2. The User undertakes to provide accurate and up-to-date information. The User bears full responsibility for the consequences caused by providing false data.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            3.3. PayWave has the right to refuse access to the Service or temporarily restrict the use of functions without explanation if there are suspicions of law violations, fraud, improper use, or other risks.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            4. Liability and Limitations
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            4.1. The PayWave Service provides technological infrastructure and a system for controlling the execution of transfer and exchange requests. All transactions are carried out through verified and selected partners (merchants) with whom the project establishes cooperation. We take measures to ensure the reliability of such executors, but are not responsible for actions performed outside the platform and our technical mechanisms.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            4.2. Exchange rates, commissions, and transaction terms are displayed in the Service interface before the transfer is made and are mandatory for execution after confirmation by the User. We guarantee that the User will receive the rate indicated at confirmation, or the transaction will be canceled with a refund.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            4.3. The execution time of transactions may depend on external factors (banks, payment systems, local restrictions) and may not always be guaranteed. PayWave makes reasonable efforts to meet the stated execution times.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            4.4. The Service does not provide investment, financial, or legal advice. The User independently makes decisions about using the platform's functionality.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            5. No License
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            5.1. The PayWave project does not have a license to conduct financial, banking, or other regulated activities. The Service operates in a peer-to-peer (P2P) model and provides infrastructure for organizing exchanges and transfers between users and executors.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            5.2. By using the Service, the User understands and accepts the nature of the platform, based on interaction with independent participants, as well as the related features.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            6. Personal Data
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            6.1. The processing of personal data is carried out in accordance with the Privacy Policy published at: <a href="https://pay-wave.co/policy/" class="text-primary" target="_blank">https://pay-wave.co/policy/</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            6.2. The User agrees to the processing of personal data, including the transfer of necessary information to third parties for the execution of transactions, verification, and compliance with legal requirements.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            7. Dispute Resolution Procedure
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            7.1. All disputes and claims are resolved through negotiations, including via the specified contact channels.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            7.2. If it is impossible to resolve the conflict out of court, the dispute may be referred to the location of the responsible person of the project or to alternative dispute resolution platforms (ODR).
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            8. Changes to Terms
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            8.1. The Service reserves the right to make changes to this Offer at any time without prior notice. The current version is available at: <a href="https://pay-wave.co/terms/" class="text-primary" target="_blank">https://pay-wave.co/terms/</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            8.2. Continued use of the Service means the User agrees to the changes in the terms.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            9. Contact Information
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            PayWave Project
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Email: <a href="mailto:info@pay-wave.co" class="text-primary">info@pay-wave.co</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Telegram: <a href="https://t.me/pw_origin_bot" class="text-primary" target="_blank">https://t.me/pw_origin_bot</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Website: <a href="https://pay-wave.co/" class="text-primary" target="_blank">https://pay-wave.co/</a>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'Terms',
        computed: {
            lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        },
    }
</script>
